import { IS_CLIENT } from '../constants';
/**
 * Returns true if the current touchpoint is an app device.
 * @return {boolean}
 */
export const isAppDevice = () => IS_CLIENT && window.getTouchpoint && window.getTouchpoint() === 'MOBILEAPP';
/**
 * Returns true if the current touchpoint is a mobile device.
 * @return {boolean}
 */
export const isMobileDevice = () => IS_CLIENT && window.getTouchpoint && (window === null || window === void 0 ? void 0 : window.getTouchpoint()) === 'MOBILE';
/**
 * Returns true if the current touchpoint is a desktop device.
 * @return {boolean}
 */
export const isDesktopDevice = () => IS_CLIENT && window.getTouchpoint && (window === null || window === void 0 ? void 0 : window.getTouchpoint()) === 'DESKTOP';
/**
 * Returns true if the current touchpoint is an Android device.
 * @return {boolean}
 */
export const isAndroid = () => IS_CLIENT && /android/i.test(navigator.userAgent);
/**
 * Returns true if the current touchpoint is an iOS device.
 * @return {boolean}
 */
export const isIos = () => IS_CLIENT && /iPad|iPhone|iPod/.test(navigator.userAgent);
/**
 * Returns true if the current userAgent is an iPad.
 * @return {boolean}
 */
export const isIPad = () => /iPad/.test(navigator.userAgent);
/**
 * Returns the current touchpoint.
 * @return {DeviceTypes}
 */
export const getTouchpoint = () => {
    if (isAppDevice()) {
        return 'APP';
    }
    if (isMobileDevice()) {
        return 'MOBILE';
    }
    return 'DESKTOP';
};
//# sourceMappingURL=touchpoint.js.map